import styled, { css } from 'styled-components';

export interface HostVideoProps {
	$mirror?: boolean;
}

export const RoomContainer = styled.div`
	position: relative;
	overflow: hidden;
	width: 100%;
	height: 100vh;
	height: calc(var(--vh, 1vh) * 100);
`;

export const GuestContainer = styled.div`
	width: 100%;
	height: 100vh;
	height: calc(var(--vh, 1vh) * 100);
	position: relative;
`;

export const HostContainer = styled.div<{$enlarged: boolean;}>`
	${({ theme, $enlarged }) => css`
		position: absolute;
		width: ${$enlarged ? 330 : 165}px;
		height: ${$enlarged ? 330 : 165}px;
		bottom: 101px;
		left: 16px;
		box-shadow: ${theme.shadows.base};
		border-radius: ${theme.radii.m};
		z-index: 2;

		@media ${theme.screens.screenGTS} {
			bottom: 32px;
			left: 32px;
		}
	`};
`;

export const EnlargeContainer = styled.div`
	${({ theme }) => css`
		position: absolute;
		top: 8px;
		right: 8px;
		width: 23px;
		height: 23px;
		z-index: 3;

		display: grid;
		place-content: center;

		border-radius: ${theme.radii.full};
		background-color: ${theme.colors.neutral[400]};
	`};
`;

export const ChangeCamContainer= styled.div`
	${({ theme }) => css`
		position: absolute;
		top: 8px;
		right: 8px;
		width: 34px;
		height: 34px;
		z-index: 3;

		display: grid;
		place-content: center;

		border-radius: ${theme.radii.full};
		background-color: ${theme.colors.neutral[200]};
	`};
`;

export const HostCamDisabled = styled.div`
	${({ theme }) => css`
		display: grid;
		place-content: center;
		height: 100%;
		overflow: hidden;
		border-radius: ${theme.radii.m};

		background-color: ${theme.colors.neutral[500]};
	`};
`;

export const ToolsSection = styled.div`
	${({ theme }) => css`
		position: absolute;
		z-index: 9;
		right: 4%;
		top: 8%;
		width: 470px;

		@media ${theme.screens.screenS} {
			width: auto;
			right: 9px;
			top: 9px;
		}
	`};
`;

export const ToolsContainer = styled.div`
	${({ theme }) => css`
		background-color: #ffffff;
		border-radius: ${theme.radii.m};
		box-shadow: ${theme.shadows.base};
		padding: 0 25px 0 20px;
	`};
`;

export interface InfoTipsProps {
	$toLeft: boolean;
}

const toLeftCss = `
	position: absolute;
	left: -78px;
	top: 82px;
`;

export const InfoTips = styled.div<InfoTipsProps>`
	${({ theme, $toLeft }) => css`
		width: ${$toLeft ? 68 : 418}px;

		${$toLeft && toLeftCss}

		@media ${theme.screens.screenS} {
			position: absolute;
			top: 87px;
			width: 100%;
			padding: 0 9px;
		}

		@media ${theme.screens.screenGTS} {
			${!$toLeft && 'margin-top: 14px;'}
		}
	`};
`;

export const ControlsContainer = styled.div`
	${({ theme }) => css`
		position: absolute;
		bottom: 26px;
		left: 50%;
		transform: translateX(-50%);
		z-index: 2;

		@media ${theme.screens.screenGTS} {
			bottom: 73px;
		}
	`}
`;

export const GuestPlaceholder = styled.div`
	${({ theme }) => css`
		width: 100%;
		height: 100vh;
		height: calc(var(--vh, 1vh) * 100);
		background-image: url(${theme.backgroundImage});
		background-size: cover;
		position: relative;
	`};
`;

export const LogoWatermark = styled.div`
	${({ theme }) => css`
		position: absolute;
		height: auto;
		top: 18px;
		left: 16px;
		width: 132px;
		z-index: 10;

		@media ${theme.screens.screenGTS} {
			top: 30px;
			right: 35px;
			left: inherit;
			width: 155px;
		}
	`};
`;

export const Logo = styled.img`
	opacity: 1;
	width: 100%;
`;

export const SharingScreenTip = styled.div`
	${({ theme }) => css`
		position: absolute;
		top: 5vh;
		top: calc(var(--vh, 1vh) * 5);
		left: 10vh;
		left: calc(var(--vh, 1vh) * 10);
		max-width: 583px;
		z-index: 9;

		@media ${theme.screens.screenS} {
			position: absolute;
			top: 87px;
			left: 0;
			width: 100%;
			max-width: 100%;
			padding: 0 9px;
		}
	`}
`;

export const Guest = styled.div`
	width: 100%;
	height: 100vh;
	height: calc(var(--vh, 1vh) * 100);
	object-fit: contain;
`;

export const BottomShadow = styled.div`
	position: absolute;
	bottom: 0;
	background: transparent linear-gradient(180deg, #22222200 0%, #22222298 100%) 0% 0% no-repeat
		padding-box;
	width: 100%;
	height: 20vh;
	z-index: 1;
`;

export const ParticipantName = styled.div`
	${({ theme }) => css`
		color: ${theme.colors.neutral[100]};
		font-weight: ${theme.fontWeights.medium};
		font-size: ${theme.fontSizes.default};
	`};
`;

export const HostPlaceholder = styled.div`
	background-color: #212121;
	display: grid;
	place-content: center;
	width: 100%;
	height: 100%;
	border-radius: 10px;
`;

export const Host = styled.div<HostVideoProps>`
	${({ theme, $mirror }) => css`
		width: 100%;
		height: 100%;
		object-fit: cover;
		${$mirror && 'transform: scaleX(-1);'}
		overflow: hidden;
		border-radius: ${theme.radii.m};
	`}
`;

export const RoomInfo = styled.div`
	${({ theme }) => css`
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding-left: 8px;
		padding-right: 8px;
		padding-bottom: 162px;

		@media ${theme.screens.screenGTS} {
			padding: 0;
		}
	`};
`;
